export default {
	'01': {
		'name': 'Январь',
		'short': 'Jan',
		'number': 1,
		'days': 31,
	},
	'02': {
		'name': 'Февраль',
		'short': 'Feb',
		'number': 2,
		'days': 28,
	},
	'03': {
		'name': 'Март',
		'short': 'Mar',
		'number': 3,
		'days': 31,
	},
	'04': {
		'name': 'Апрель',
		'short': 'Apr',
		'number': 4,
		'days': 30,
	},
	'05': {
		'name': 'Май',
		'short': 'May',
		'number': 5,
		'days': 31,
	},
	'06': {
		'name': 'Июнь',
		'short': 'Jun',
		'number': 6,
		'days': 30,
	},
	'07': {
		'name': 'Июль',
		'short': 'Jul',
		'number': 7,
		'days': 31,
	},
	'08': {
		'name': 'Август',
		'short': 'Aug',
		'number': 8,
		'days': 31,
	},
	'09': {
		'name': 'Сентябрь',
		'short': 'Sep',
		'number': 9,
		'days': 30,
	},
	'10': {
		'name': 'Октябрь',
		'short': 'Oct',
		'number': 10,
		'days': 31,
	},
	'11': {
		'name': 'Ноябрь',
		'short': 'Nov',
		'number': 11,
		'days': 30,
	},
	'12': {
		'name': 'Декабрь',
		'short': 'Dec',
		'number': 12,
		'days': 31,
	},
}
